import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ResponseMetaData } from "../../entities/global";
import { getWheelBonuses, getWheelEntites, getWheelProfiles } from "./thunks";
import { FortuneWheelBonus, FortuneWheelEntity, FortuneWheelProfile } from "../../entities/wheelGame_v2";

interface FortuneWheelTableState {
  loading: boolean;
  meta: {
    bonuse: ResponseMetaData;
    entity: ResponseMetaData;
    profile: ResponseMetaData;
  };
  bonuses: FortuneWheelBonus[];
  entites: FortuneWheelEntity[];
  profiles: FortuneWheelProfile[];

  needUpdateBonuses: boolean;
  needUpdateEntites: boolean;
  needUpdateProfiles: boolean;
}

const initialState: FortuneWheelTableState = {
  loading: false,

  bonuses: [],
  entites: [],
  profiles: [],

  needUpdateBonuses: true,
  needUpdateEntites: true,
  needUpdateProfiles: true,

  meta: {
    bonuse: {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
    },
    entity: {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
    },
    profile: {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
    },
  },
};

export const fortuneWheelTableStore = createSlice({
  name: "fortuneWheel",
  initialState: initialState,
  reducers: {
    handlerNeedUpdate: (
      state,
      action: PayloadAction<{
        key: "bonus" | "entity" | "profile";
        value: boolean;
      }>
    ) => {
      const { key, value } = action.payload;

      if (key === "bonus") state.needUpdateBonuses = value;
      if (key === "entity") state.needUpdateEntites = value;
      if (key === "profile") state.needUpdateProfiles = value;
    },
  },
  extraReducers: (builder) => {
    // getWheelBonuses
    builder.addCase(getWheelBonuses.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(getWheelBonuses.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload
      state.bonuses = data;
      state.meta.bonuse = meta

      state.loading = false
      state.needUpdateBonuses = false
    })
    // getWheelProfiles
    builder.addCase(getWheelProfiles.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(getWheelProfiles.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload;
      state.profiles = data;
      state.meta.profile = meta;

      state.loading = false;
      state.needUpdateProfiles = false;
    })
    // getWheelEntites
    builder.addCase(getWheelEntites.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(getWheelEntites.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload;
      state.entites = data;
      state.meta.entity = meta;

      state.loading = false;
      state.needUpdateEntites = false;
    })
  },
});

export const { handlerNeedUpdate } = fortuneWheelTableStore.actions;

export default fortuneWheelTableStore.reducer;
